exports = module.exports = require("../../../../../../../../../../../../node_modules/css-loader/lib/css-base.js")(false);
// imports


// module
exports.push([module.id, ".giftcard-forgot-container .substrate__popup-change-pass input {\n  border: 1px solid #BEBEBE;\n  width: 100%;\n  height: 50px;\n}\n.giftcard-forgot-container button.btn-link {\n  padding: 0;\n  border: 0;\n  height: -webkit-fit-content;\n  height: -moz-fit-content;\n  height: fit-content;\n  font-family: \"OpenSans-Regular\";\n  text-decoration: underline;\n  font-size: 16px;\n  color: #B31E23;\n  line-height: 1.3;\n}\n.giftcard-forgot-container .separate p {\n  font-weight: bold;\n  font-size: 14px;\n  opacity: 1;\n  line-height: 1.4;\n}", ""]);

// exports
